import { render, staticRenderFns } from "./InputToken.vue?vue&type=template&id=27008994&scoped=true&"
import script from "./InputToken.vue?vue&type=script&lang=js&"
export * from "./InputToken.vue?vue&type=script&lang=js&"
import style0 from "./InputToken.vue?vue&type=style&index=0&id=27008994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27008994",
  null
  
)

export default component.exports